module.exports = __webpack_public_path__ + "static/media/select_gray_up.4e533b7e.svg";